<template>
  <material-card
    :title="$t('components.plancreationwizard.plan_settings')"
    :color="$vuetify.theme.themes.light.secondary"
    icon="settings"
    style="margin-top: 30px"
  >
    <v-card-text>
      <v-form
        ref="generalSettingsCheckboxes"
        v-model="valid"
        :disabled="disabled"
      >
        <v-layout row wrap>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <v-checkbox
              v-model="generalSettings.AutogenerateCertificate"
              :label="
                $t('components.plancreationwizard.autogenerate_certificates')
              "
            ></v-checkbox>
          </v-col>
          <!-- <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <v-checkbox
              v-model="generalSettings.PlanSettings.HasBilling"
              :label="$t('views.plangeneralparameters.include_billing')"
            ></v-checkbox>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="4"
            lg="3"
            class="pt-0 pb-0"
            v-if="generalSettings.PlanSettings.HasBilling"
          >
            <v-checkbox
              v-model="
                generalSettings.PlanSettings.HasEmployerContributionsPerTerm
              "
              :label="
                $t(
                  'views.plangeneralparameters.employer_contributions_per_term'
                )
              "
            ></v-checkbox>
          </v-col> -->
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <v-checkbox
              v-model="hasClasses"
              :label="$t('components.plancreationwizard.has_classes')"
            ></v-checkbox>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="4"
            lg="3"
            v-if="hasClasses"
            class="pt-0 pb-0"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-container pa-0>
                  <v-row no-gutters>
                    <v-col>
                      <v-combobox
                        :rules="[rules.requiredStr]"
                        :value="classesStr.split(',').filter((e) => e)"
                        @input="classesStr = $event.filter((e) => e).join(',')"
                        hide-selected
                        :label="$t('components.plancreationwizard.classes')"
                        :hide-no-data="!inputClass"
                        :search-input.sync="inputClass"
                        multiple
                        small-chips
                        class="required"
                      >
                        <template
                          v-slot:selection="{ attrs, item, parent, selected }"
                        >
                          <v-chip
                            v-bind="attrs"
                            color="primary"
                            :input-value="selected"
                            label
                            small
                          >
                            <span class="pr-2">
                              {{ item }}
                            </span>
                            <v-icon small @click="parent.selectItem(item)">
                              close
                            </v-icon>
                          </v-chip>
                        </template>
                      </v-combobox>
                    </v-col>
                    <v-col
                      style="margin-top: 20px; margin-left: 3px"
                      cols="auto"
                    >
                      <v-icon v-bind="attrs" v-on="on">help</v-icon>
                    </v-col>
                  </v-row>
                </v-container>
              </template>
              <span>
                {{ $t("components.plancreationwizard.classes_tooltip") }}
              </span>
            </v-tooltip>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <v-checkbox
              v-model="hasOccupations"
              :label="$t('components.plancreationwizard.has_occupations')"
            ></v-checkbox>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="4"
            lg="3"
            v-if="hasOccupations"
            class="pt-0 pb-0"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-container pa-0>
                  <v-row no-gutters>
                    <v-col>
                      <v-combobox
                        :rules="[$rules.required]"
                        :value="occupationsStr.split(',').filter((e) => e)"
                        @input="
                          occupationsStr = $event.filter((e) => e).join(',')
                        "
                        hide-selected
                        :label="$t('components.plancreationwizard.occupations')"
                        :hide-no-data="!inputOccupations"
                        :search-input.sync="inputOccupations"
                        multiple
                        small-chips
                      >
                        <template
                          v-slot:selection="{ attrs, item, parent, selected }"
                        >
                          <v-chip
                            v-bind="attrs"
                            color="primary"
                            :input-value="selected"
                            label
                            small
                          >
                            <span class="pr-2">
                              {{ item }}
                            </span>
                            <v-icon small @click="parent.selectItem(item)">
                              close
                            </v-icon>
                          </v-chip>
                        </template>
                      </v-combobox>
                    </v-col>
                    <v-col
                      style="margin-top: 20px; margin-left: 3px"
                      cols="auto"
                    >
                      <v-icon v-bind="attrs" v-on="on">help</v-icon>
                    </v-col>
                  </v-row>
                </v-container>
              </template>
              <span>
                {{ $t("components.plancreationwizard.occupations_tooltip") }}
              </span>
            </v-tooltip>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <v-checkbox
              v-model="generalSettings.PlanSettings.TrackContinuousService"
              :label="$t('components.plancreationwizard.track_continuous_service')"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <v-checkbox
              v-model="generalSettings.PlanSettings.TrackCreditedService"
              :label="$t('components.plancreationwizard.track_credited_service')"
            ></v-checkbox>
          </v-col>
        </v-layout>
      </v-form>
    </v-card-text>
  </material-card>
</template>
<script>
// import AutoSelect from "@/components/AutoSelect";
// import NoAutocompleteTextfield from "@/components/NoAutocompleteTextfield";
import { mapGetters, mapActions } from "vuex";

export default {
  // components: { AutoSelect, NoAutocompleteTextfield },
  props: ["generalSettings", "disabled", "organizationId", "draftId", "coverages"],
  data() {
    return {
      inputClass: "",
      inputOccupations: "",
      hasClasses: false,
      hasOccupations: false,
      classesStr: "",
      occupationsStr: "",
      valid: false,
      rules: {
        atLeastPremiumsOrRemittances: () => {
          return (
            this.generalSettings.PlanSettings.HasPremiums === true ||
            this.generalSettings.PlanSettings.HasRemittances === true ||
            this.$t("validation.at_least_premiums_or_remittances")
          );
        },
        requiredStr: (v) => {
          console.log(v);
          return v.length > 0 || this.$t("validation.required");
        },
      },
      coverage: null,
    };
  },
  computed: {
    ...mapGetters("plansMembers", ["options"]),
  },
  watch: {
    valid: {
      handler(v) {
        console.log("plan settings valid: ", v);
        this.$emit("valid", v);
      },
    },
    hasClasses: {
      handler(v) {
        console.log("----------------------------------------------------", v);
        this.$emit("has-classes", v);
        if (!v) {
          this.classesStr = "";
        }
      },
    },
    hasOccupations: {
      handler(v) {
        this.$emit("has-occupations", v);
        if (!v) {
          this.occupationsStr = "";
        }
      },
    },
    classesStr: {
      handler(v) {
        this.$emit("update-classes", v);
      },
    },
    occupationsStr: {
      handler(v) {
        this.$emit("update-occupations", v);
      },
    },
    generalSettings: {
      async handler(v) {
        if (v) {
          if (v) {
            console.log(this.coverages);
            this.generalSettings.PlanSettings.HasPensionBenefit = true;
            this.generalSettings.PlanSettings.HasBilling = true;
            this.generalSettings.PlanSettings.HasEmployerContributionsPerTerm = true;
            if (this.coverages.length === 0) {
              try {
                this.coverage = (await this.getPensionCoverage({
                  organizationId: this.organizationId,
                  draftId: this.draftId,
                })).data;
              } catch (error) {
                this.error = error;
              }
            } else {
              this.coverage = this.coverages[0];
            }
            this.$emit("update-coverage", this.coverage);
          }
          this.generalSettings.PlanSettings.IncludeTrustFund = true;
          if (v.PlanSettings.Classes) {
            this.hasClasses = true;
            this.classesStr = v.PlanSettings.Classes.replace(/\[/g, "")
              .replace(/\]/g, "")
              .replace(/"/g, "");
            this.classesArray = JSON.parse(
              this.generalSettings.PlanSettings.Classes
            );
          }
          if (v.Occupations) {
            this.hasOccupations = true;
            this.occupationsStr = v.Occupations.replace(/\[/g, "")
              .replace(/\]/g, "")
              .replace(/"/g, "");
          }
        }
      },
      immediate: true,
    },
    // "generalSettings.PlanSettings.HasBilling": {
    //   handler(v) {
    //     if (!v) {
    //       // this.generalSettings.TrackHours = false;
    //       this.generalSettings.PlanSettings.HasEmployerContributionsPerTerm = false;
    //     }
    //   },
    // },
  },
  methods: {
    ...mapActions("plansMembers", ["getPensionCoverage"]),
    atLeastPremiumsOrRemittances() {
      return (
        this.generalSettings.PlanSettings.HasPremiums === true ||
        this.generalSettings.PlanSettings.HasRemittances === true ||
        this.$t("validation.at_least_premiums_or_remittances")
      );
    },
  },
};
</script>
